// Utils
import {
    getConfig,
} from '@shared/utils/config';

// Types
import {
    GatewayAuthData,
} from '@shared/types/auth';


type FanTokenDirectPurchaseParams = GatewayAuthData & {
    currency: Record<string, unknown>;
    webApp?: boolean;
};

export const getFanTokenDirectPurchaseGatewayURL = ({
    deviceId = '',
    currency = {},
    ...params
}: FanTokenDirectPurchaseParams) => {
    const baseUrl = getConfig().fanTokenDirectPurchaseGatewayUrl || process.env.VUE_APP_GATEWAY_URL_FT_DP;

    const fanTokenCurrencyId = typeof currency === 'string' ? currency : '';

    return Object.entries({
        deviceUid: deviceId,
        fanTokenCurrencyId: fanTokenCurrencyId,
        ...params,
    }).reduce((acc, [key, value], index) => `${acc}${index > 0 ? '&' : '?'}${key}=${encodeURIComponent(value)}`, baseUrl);
};